// ---------------------- Toast Details ----------------------

export const SET_TOAST_DETAILS = "SET_TOAST_DETAILS";
export const RESET_TOAST_DETAILS = "RESET_TOAST_DETAILS";